export const CallQueueKeys = {
    'queueName': 'Queue Name',
    'extension': 'Extension',
    'email': 'Email',
    'site': 'Site',
    'members': 'Members (Ext)',
    'hours': 'Hours',
    'greeting': 'Greeting',
    'audioWhileConnecting': 'Audio While Connecting',
    'holdMusic': 'Hold Music',
    'interruptAudio': 'Interrupt Audio',
    'interruptPrompt': 'Interrupt Prompt',
    'ringType': 'Ring Type',
    'userRingTime': 'User Ring Time',
    'totalRingTime': 'Total Ring Time',
    'wrapUpTime': 'Wrap Up Time',
    'voicemailGreeting': 'Voicemail Greeting',
    'afterHoursBehavior': 'After Hours Behavior',
    'maxWaitTimeAction': 'Max Wait Time Action',
    'maxWaitTimeDestination': 'Max Wait Time Destination',
    'maxCallersAction': 'Max Callers Action',
    'maxCallersDestination': 'Max Callers Destination',
    'queueFullAction': 'When Queue is Full',
    'queueFullDestination': 'Queue Full Destination',
    'maxQueueWaitTimeAction': 'When Max Time is Reached',
    'maxQueueWaitTimeDestination': 'Time Reached Destination',
    'voicemailRecipient': 'Voicemail Recipient',
    'voicemailRecipientExt': 'Voicemail Recipient Ext',
    'afterHoursAction': 'After Hours Behavior',
    'afterHoursDestination': 'After Hours Destination',
    'managers': 'Queue Manager',
    'maxCallers': 'Callers In Queue',
    'memberStatus': 'Member Queue Status'
}
